<template>
  <a v-bind:href="wxurl">
    <div class="container">
        <div class="img-container">
          <img v-bind:src="img" alt="pic" class="poster">
        </div>
        <div class="text">
          <p>{{ name }}</p>
          <span class="time">{{ time }}</span>
        </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Card',
  methods: {
    getImg (url) {
      return `https://niu.h5anli.com/${url}`
    },
    getWeb (url) {
      return `https://www.h5anli.com/${url}`
    }
  },
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          wxurl: 'https://www.h5anli.com/cases/201610/wuyuetian.html',
          id: '2373',
          fengpi: 'https://niu.h5anli.com/Uploads3/201610/1476428921.jpg',
          name: '光明莫斯利安：五月天'
        }
      }
    },
    img: {
      type: String,
      default: function () {
        return 'Uploads3/201610/1476428921.jpg'
      }
    },
    wxurl: {
      type: String,
      default: function () {
        return '/cases/201610/wuyuetian.html'
      }
    },
    name: {
      type: String,
      default: function () {
        return '光明莫斯利安：五月天'
      }
    },
    time: {
      type: String,
      default: function () {
        return '刚刚'
      }
    }
  }
}
</script>

<style scoped>
  .container {
    background-color: #fff;
    display: flex;
    padding: 1.333vw 2.667vw;
    box-sizing: border-box;
    font-size: 0;
    border-radius: .5rem;
    margin-bottom: 1rem;
  }
  .img-container {
    width: 36vw;
    height: 20vw;
  }

  .poster {
    display: block;
    width: 36vw;
    height: 20vw;
    max-width: 100%;
  }

  .text {
    position: relative;
    font-size: 4.1vw;
    width: 53.6vw;
    padding-left: 2vw;
  }

  p {
    font-weight: 700;
  }

  .time {
    position: absolute;
    color: #b6b6b6;
    font-size: 2.6vw;
    bottom: .5vw;
    right: .5vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/Card.vue